(function () {
    function initTickerSlider(sectionElement) {
        var tickerElement = sectionElement.querySelector('[data-home-ticker-slider]');
        var previousButton = sectionElement.querySelector('[data-home-ticker-prev]');
        var nextButton = sectionElement.querySelector('[data-home-ticker-next]');
        var mobileSlides = Number(tickerElement && tickerElement.dataset.homeTickerMobileSlides) || 1;
        var desktopSlides = Number(tickerElement && tickerElement.dataset.homeTickerDesktopSlides) || 3;

        if (!tickerElement || typeof window.Swiper === 'undefined') {
            return;
        }

        if (tickerElement.swiper) {
            tickerElement.swiper.destroy(true, true);
        }

        new window.Swiper(tickerElement, {
            slidesPerView: mobileSlides,
            slidesPerGroup: 1,
            spaceBetween: 0,
            speed: 620,
            loop: false,
            watchOverflow: true,
            breakpoints: {
                750: {
                    slidesPerView: desktopSlides,
                    slidesPerGroup: 1,
                    spaceBetween: 0
                }
            },
            navigation: previousButton && nextButton ? {
                prevEl: previousButton,
                nextEl: nextButton
            } : undefined
        });
    }

    function isInteractiveTarget(target) {
        return Boolean(target.closest('a, button, input, select, textarea, summary, [role="button"], [data-banner-previous], [data-banner-next], [data-banner-pagination]'));
    }

    function goToBannerLink(slideElement) {
        var url = slideElement && slideElement.dataset.bannerLink;

        if (!url) {
            return;
        }

        window.location.href = url;
    }

    function initBannerLinks(sectionElement, sliderElement) {
        if (sectionElement._filadelfiaBannerLinksBound) {
            return;
        }

        sectionElement._filadelfiaBannerLinksBound = true;

        sectionElement.addEventListener('click', function (event) {
            var slideElement = event.target.closest('[data-banner-slide][data-banner-link]');

            if (
                !slideElement ||
                isInteractiveTarget(event.target) ||
                event.defaultPrevented ||
                (sliderElement.swiper && sliderElement.swiper.allowClick === false)
            ) {
                return;
            }

            goToBannerLink(slideElement);
        });

        sectionElement.addEventListener('keydown', function (event) {
            var slideElement = event.target.closest('[data-banner-slide][data-banner-link]');

            if (
                !slideElement ||
                isInteractiveTarget(event.target) ||
                (event.key !== 'Enter' && event.key !== ' ')
            ) {
                return;
            }

            event.preventDefault();
            goToBannerLink(slideElement);
        });
    }

    function initBannerSlider(sectionElement) {
        if (!sectionElement || sectionElement.dataset.initialized === 'true') {
            return;
        }

        var sliderElement = sectionElement.querySelector('[data-home-hero-swiper]');

        if (!sliderElement || typeof window.Swiper === 'undefined') {
            return;
        }

        sectionElement.dataset.initialized = 'true';
        initTickerSlider(sectionElement);
        initBannerLinks(sectionElement, sliderElement);

        var previousButton = sectionElement.querySelector('[data-banner-previous]');
        var nextButton = sectionElement.querySelector('[data-banner-next]');
        var paginationElement = sectionElement.querySelector('[data-banner-pagination]');
        var slideCount = sliderElement.querySelectorAll('.swiper-slide').length;

        if (slideCount <= 1) {
            return;
        }

        function syncMobileHeroHeight() {
            if (window.innerWidth > 749) {
                sliderElement.style.height = '';
                var desktopWrapper = sliderElement.querySelector('.swiper-wrapper');
                if (desktopWrapper) {
                    desktopWrapper.style.height = '';
                }
                sliderElement.querySelectorAll('.swiper-slide').forEach(function (slideElement) {
                    slideElement.style.height = '';
                });
                return;
            }

            var activeSlide = sliderElement.querySelector('.swiper-slide-active') || sliderElement.querySelector('.swiper-slide');
            var activeImage = activeSlide && activeSlide.querySelector('.filadelfia-home-hero__image');

            if (!activeImage) {
                return;
            }

            var imageHeight = activeImage.getBoundingClientRect().height || activeImage.naturalHeight;

            if (!imageHeight) {
                return;
            }

            var heightValue = Math.ceil(imageHeight) + 'px';
            var wrapperElement = sliderElement.querySelector('.swiper-wrapper');

            sliderElement.style.height = heightValue;

            if (wrapperElement) {
                wrapperElement.style.height = heightValue;
            }

            sliderElement.querySelectorAll('.swiper-slide').forEach(function (slideElement) {
                slideElement.style.height = heightValue;
            });
        }

        var heroSwiper = new window.Swiper(sliderElement, {
            slidesPerView: 1,
            speed: 820,
            loop: true,
            autoHeight: true,
            effect: 'slide',
            autoplay: {
                delay: 5200,
                disableOnInteraction: false
            },
            pagination: paginationElement ? {
                el: paginationElement,
                clickable: true
            } : undefined,
            navigation: previousButton && nextButton ? {
                prevEl: previousButton,
                nextEl: nextButton
            } : undefined
        });

        heroSwiper.on('slideChangeTransitionEnd', syncMobileHeroHeight);
        heroSwiper.on('imagesReady', syncMobileHeroHeight);
        window.addEventListener('resize', syncMobileHeroHeight);

        sliderElement.querySelectorAll('img').forEach(function (imageElement) {
            imageElement.addEventListener('load', function () {
                heroSwiper.updateAutoHeight(0);
                syncMobileHeroHeight();
            }, { once: true });
        });

        window.setTimeout(syncMobileHeroHeight, 0);
        window.setTimeout(syncMobileHeroHeight, 300);
    }

    window.filadelfiaBannerSlider = {
        init: initBannerSlider
    };
})();
